export default __webpack_public_path__ + "static/media/O-102.8c74f957.png";